import {
  DropdownProps,
  useFieldContext,
  useFieldRegister
} from "@bps/fluent-ui";

import { SoftwarePackageVersionDropDown } from "./SoftwarePackageVersionDropDown";

type SoftwarePackageVersionFormDropDownProps = Omit<
  DropdownProps,
  "selectedKey" | "selectedKeys"
>;

export const SoftwarePackageVersionFormDropDown = (
  props: SoftwarePackageVersionFormDropDownProps
) => {
  const { name, disabled, multiSelect, ...dropdownProps } = props;

  useFieldRegister(name);
  const { setFieldValue, value, disabledForm, meta } = useFieldContext(name);

  const handleChange = (event, option) => {
    if (!multiSelect) {
      setFieldValue(option.key);
    } else {
      const prev = (value || []) as string[];
      const next = prev.filter(key => key !== option.key);
      if (prev.length === next.length) {
        next.push(option.key);
      }

      setFieldValue(next);
    }

    props.onChange && props.onChange(event, option);
  };

  const selectedKey = !multiSelect ? value : undefined;
  const selectedKeys = multiSelect ? value : undefined;

  const isDisabled = disabledForm || disabled;

  return (
    <SoftwarePackageVersionDropDown
      {...dropdownProps}
      name={name}
      multiSelect={multiSelect}
      selectedKey={selectedKey as any}
      selectedKeys={selectedKeys as any}
      onChange={handleChange}
      disabled={isDisabled}
      errorMessage={meta?.error}
    />
  );
};
